/* unplugin-vue-components disabled */import { render } from "./AuthLinkForm.vue?vue&type=template&id=0d9b8d0c&scoped=true&ts=true"
import script from "./AuthLinkForm.vue?vue&type=script&lang=ts"
export * from "./AuthLinkForm.vue?vue&type=script&lang=ts"

import "./AuthLinkForm.vue?vue&type=style&index=0&id=0d9b8d0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9b8d0c"]])

export default __exports__